<template>
  <div>
    <h1 v-if="false" class="red lighten-3 ma-8 pa-4 text-center">
      Sorry, quote is under technical service
    </h1>
    <div v-else class="app-content-faq">
      <div class="app-content-faq__expansion">
        <CustomError v-if="is_error" />
        <Loading v-if="is_loading" />
        <div v-if="!is_loading">
          <div class="app-content-inventory__about-title">
            Total price: ${{ editedOrder.currentPrice.toFixed(2) }}
          </div>
          <v-form>
            <v-expansion-panels focusable v-model="panel" mb-4>
              <v-expansion-panel
                v-for="(field, index) in enabledFields"
                :key="field._id"
                class="pa-0"
                @change="panelHeaderClick(index)"
              >
                <v-expansion-panel-header
                  class="py-0"
                  :disable-icon-rotate="isFieldSelected(field._id)"
                  :title="`${field.data.title}: ${valueForHeader(field._id)}`"
                >
                  <v-layout mr-3 class="align-center parent">
                    <div
                      :class="
                        `${getStatusColor(field._id)}--text${
                          isFieldValid(field._id) || isFieldNotValid(field._id)
                            ? ' font-weight-bold'
                            : ''
                        }`
                      "
                      class="d-flex justify-start align-center mr-1 subtitle-1"
                    >
                      {{ field.data.title }}
                      <span
                        :class="{
                          'error--text': !isFieldValid(field._id) || isFieldNotValid(field._id)
                        }"
                        >{{ field.data.required ? '*' : '' }}</span
                      >
                    </div>
                    <div class="d-inline-block align-center mr-6 pr-2 font-italic font-weight-thin">
                      <span
                        :class="`${getStatusClass(field._id)}`"
                        v-for="(item, index) in getValuesForHeaderList(field._id)"
                        :key="index"
                        class="ma-1 header-chip"
                        >{{ item }}</span
                      >
                    </div>
                  </v-layout>
                  <v-spacer></v-spacer>

                  <!-- <v-layout row justify-end pl-1 nowrap>
                  <div :class="`${getStatusColor(field._id)}--text white-spaced`" class="align-center mr-1">
                    {{getTotalFieldPrice(field._id)}}
                    <v-icon
                        outline
                        @click.stop="()=>addComment(field, index)"
                        v-if="!field.hasComment"
                        :color="getStatusColor(field._id)"
                    >mdi-comment-plus-outline</v-icon>
                    <v-icon
                        outline
                        v-if="field.hasComment"
                        :color="getStatusColor(field._id)"
                    >mdi-comment-text-outline</v-icon>
                  </div>
                  </v-layout>-->
                  <template v-slot:actions>
                    <span
                      :class="`${getStatusColor(field._id)}--text`"
                      class="white-spaced mt-1 mr-1"
                      >{{ getTotalFieldPrice(field._id) }}</span
                    >

                    <v-icon
                      class="mr-1 keep-icon-upright"
                      outline
                      @click.stop="() => addComment(field, index)"
                      v-if="!field.hasComment"
                      :color="getStatusColor(field._id)"
                      >mdi-comment-plus-outline</v-icon
                    >

                    <v-icon
                      class="mr-1 keep-icon-upright"
                      outline
                      v-if="field.hasComment"
                      :color="getStatusColor(field._id)"
                      >mdi-comment-text-outline</v-icon
                    >

                    <v-icon v-if="!isFieldSelected(field._id)" :color="getStatusColor(field._id)"
                      >mdi-chevron-down</v-icon
                    >
                    <v-icon
                      class="keep-icon-upright"
                      v-if="isFieldNotValid(field._id)"
                      :color="getStatusColor(field._id)"
                      >mdi-alert-circle</v-icon
                    >
                    <v-icon
                      class="keep-icon-upright"
                      v-if="isFieldValid(field._id)"
                      :color="getStatusColor(field._id)"
                      >mdi-checkbox-marked-circle-outline</v-icon
                    >
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0 ma-0">
                  <FormField
                    :field="field"
                    :onChange="setFieldValue"
                    :defaultValue="getDefaultValue(field.data.title)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <h1 class="app-content-inventory__about-title">
              Comment for Order
            </h1>
            <v-textarea
              id="orderComment"
              v-model.trim="order_comment"
              clearable
              :counter="counter"
              outlined
              placeholder="Type comment for order"
              rounded
              :rows="3"
              :maxlength="counter"
              solo
            ></v-textarea>
            <v-layout row wrap>
              <v-btn
                rounded
                submit
                color="success"
                @click.prevent="sendOrder"
                :disabled="!valid"
                title="Send"
              >
                Send
              </v-btn>
              <span v-if="!valid" class="error--text pa-2 caption font-italic"
                >*Please answer to all required questions</span
              >
              <v-spacer></v-spacer>
              <v-btn rounded submit color="error" @click.prevent="clickResetButton">Reset</v-btn>
            </v-layout>
          </v-form>
        </div>
      </div>
    </div>
    <DialogMessageBox v-if="isDialogVisible" v-bind="dialogOptions" />
  </div>
</template>

<script>
import FormField from './c/FormField'
import Loading from '@/components/Loading'
import CustomError from '@/components/CustomError'
import { mapGetters, mapActions } from 'vuex'
import NO_ITEM from '@/constants/noItem'
import ORDER_STATUSES from '@/constants/orderStatuses'
import DialogMessageBox from '@/components/DialogMessageBox'

export default {
  name: 'Quote',
  components: {
    FormField,
    Loading,
    CustomError,
    DialogMessageBox
  },
  data() {
    return {
      enabledFields: [],
      fieldsState: [],
      order_comment: '',
      panel: null,
      isDialogVisible: false,
      dialogOptions: null
    }
  },
  props: {
    validStatusColor: {
      type: String,
      default: 'accent'
    },
    notValidStatusColor: {
      type: String,
      default: 'error'
    },
    notSelectedStatusColor: {
      type: String,
      default: 'white'
    },
    counter: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    fields() {
      return this.allFields()
    },
    editedOrder() {
      return this.getEditedOrder()
    },
    valid() {
      this.setFieldsEnabledProperty()
      let res = this.enabledFields.every(
        f => f._id in this.editedOrder.fieldsValues || !f.data.required
      )
      if (res) {
        res = Object.keys(this.editedOrder.fieldsValues).every(
          fieldId => this.editedOrder.fieldsValues[fieldId].valid
        )
      }
      return res
    },
    is_loading() {
      return this.isLoading()
    },
    is_error() {
      return this.isError()
    }
  },
  watch: {
    fields: function(values) {
      if (values.length > 0) {
        this.fieldsState = [...values]
        this.setFieldsEnabledProperty()
        values.forEach(field => {
          if (field.data.imageMode && field.data.imageMode != 'No image') {
            this.loadThumbnails(field)
          }
        })
      }
    },
    panel: function(newPanelIndex, oldPanelIndex) {
      if (this.enabledFields.length > 0) {
        this.checkComment(this.enabledFields[oldPanelIndex])
      }
    },
    order_comment: function(newVal) {
      this.setOrderComment(newVal)
    }
  },
  methods: {
    ...mapGetters('fields', ['allFields', 'isLoading', 'isError']),
    ...mapActions('fields', ['load', 'loadActive']),
    ...mapGetters('user', ['user']),
    ...mapActions('orders', ['add']),

    ...mapGetters('order', ['getEditedOrder']),
    ...mapActions('order', [
      'setFieldValue',
      'setOrderComment',
      'clearEditedOrder',
      'setEnabledFields'
    ]),
    ...mapActions('images', ['loadThumbnails']),
    isFieldEnabled(field) {
      if (field.data.hasDependencies) {
        return Object.keys(field.data.dependencies).every(key => {
          if (!this.fields.some(item => item._id == key)) return true // if control field already not exist
          if (!this.editedOrder.fieldsValues[key]) return false // if field not selected yet

          const otherField = this.fieldsState.filter(
            // getting control field
            field => field._id == key
          )[0]

          return field.data.dependencies[key].every(id => {
            // checkign all contol options
            if (!otherField.data.attrs.options.some(opt => opt.id == id)) {
              // if control option already not exist
              return true
            }
            const opt = otherField.data.attrs.options.filter(
              // getting control option
              opti => opti.id == id
            )[0]
            if (Array.isArray(this.editedOrder.fieldsValues[otherField._id].value)) {
              return this.editedOrder.fieldsValues[otherField._id].value.some(val => {
                return val.text == opt.title
              })
            } else {
              return this.editedOrder.fieldsValues[otherField._id].value.text == opt.text
            }
          })
        })
      }
      return true
    },
    setFieldsEnabledProperty() {
      this.fieldsState.forEach(field => (field.enabled = this.isFieldEnabled(field)))
      this.enabledFields = this.fieldsState.filter(field => field.enabled)
      this.setEnabledFields(this.enabledFields)
    },
    panelHeaderClick(index) {
      try {
        const expansionPanelsTop = document
          .querySelector('.v-expansion-panels')
          .getBoundingClientRect().top
        const panelHeaderHeight = document.querySelector('.v-expansion-panel-header').offsetHeight
        const targetTop = expansionPanelsTop + panelHeaderHeight * index
        const { bottom } = (
          document.querySelector('.app-header__menu') || document.querySelector('header')
        ).getBoundingClientRect()
        window.scrollBy(0, targetTop - bottom)
      } catch {}
    },
    isFieldSelected(fieldId) {
      return fieldId in this.editedOrder.fieldsValues
    },
    isFieldValid(fieldId) {
      return this.isFieldSelected(fieldId) && this.editedOrder.fieldsValues[fieldId].valid
    },
    isFieldNotValid(fieldId) {
      return this.isFieldSelected(fieldId) && !this.editedOrder.fieldsValues[fieldId].valid
    },
    checkComment(field) {
      if (field && field.hasComment && !field.data.comment) {
        field.hasComment = false
      }
    },
    addComment(field, index) {
      if (this.panel != index) this.panel = index
      this.$set(field, 'hasComment', 'true')
    },
    // getCommentRules() {
    //   return [
    //     v =>!v || (v && v.length <= this.counter) ||
    //       `Max ${this.counter} characters`
    //   ];
    // },
    getDefaultValue(title) {
      if (this.user()) {
        if (title == 'User name') return this.user().nick
        if (title == 'E-mail') return this.user().email
      }
    },
    valueForHeader(fieldId) {
      if (fieldId in this.editedOrder.fieldsValues) {
        if (!this.editedOrder.fieldsValues[fieldId].valid) {
          return ' – ' + this.editedOrder.fieldsValues[fieldId].errMsg
        }
        const value = this.editedOrder.fieldsValues[fieldId].value
        if (value == undefined) return ''
        if (Array.isArray(value)) {
          return (
            ' – ' +
            value
              .map(item => `${item.text}${this.getItemCount(item)} ${this.getItemPrice(item)}`)
              .join(', ')
          )
        }
        if (value.hasOwnProperty('text')) {
          return ` – ${value.text}${this.getItemCount(value)} ${this.getItemPrice(value)}`
        }
        return value
      } else return ''
    },
    getValuesForHeaderList(fieldId) {
      if (fieldId in this.editedOrder.fieldsValues) {
        if (!this.editedOrder.fieldsValues[fieldId].valid) {
          return [this.editedOrder.fieldsValues[fieldId].errMsg]
        }
        const value = this.editedOrder.fieldsValues[fieldId].value
        if (value == undefined) return []
        if (Array.isArray(value)) {
          return value.map(
            item => `${item.text}${this.getItemCount(item)} ${this.getItemPrice(item)}`
          )
        }
        if (value.hasOwnProperty('text')) {
          return [`${value.text}${this.getItemCount(value)} ${this.getItemPrice(value)}`]
        }
        return [value]
      } else return []
    },
    getTotalFieldPrice(fieldId) {
      const sum = this.getTotalFieldSum(fieldId)
      return sum ? `$${sum}` : ''
    },
    getTotalFieldSum(fieldId) {
      if (fieldId in this.editedOrder.fieldsValues) {
        if (!this.editedOrder.fieldsValues[fieldId].valid) return ''
        const value = this.editedOrder.fieldsValues[fieldId].value
        if (value == undefined) return ''
        if (Array.isArray(value)) {
          return value
            .reduce((sum, item) => {
              if (item.price) {
                if (item.count) sum += item.count * item.price
                else sum += parseFloat(item.price)
              }
              return sum
            }, 0)
            .toFixed(2)
        }
        if (value.price) {
          if (value.count) return (value.count * value.price).toFixed(2)
          else return parseFloat(value.price).toFixed(2)
        }
        return ''
      } else return ''
    },
    getItemCount(item) {
      if (item.count) return `(${item.count})`
      return ''
    },
    getItemPrice(item) {
      if (item.price) {
        if (item.count) return ` - $ ${item.count * item.price}`
        else return ` - $ ${item.price}`
      }
      return ''
    },
    getStatusColor(fieldId) {
      if (!this.isFieldSelected(fieldId)) return this.notSelectedStatusColor
      if (this.isFieldValid(fieldId)) return this.validStatusColor
      if (this.isFieldNotValid(fieldId)) return this.notValidStatusColor
    },
    getStatusClass(fieldId) {
      if (!this.isFieldSelected(fieldId)) {
        return `${this.notSelectedStatusColor}--text`
      }
      if (this.isFieldValid(fieldId)) return 'valid-chip'
      if (this.isFieldNotValid(fieldId)) {
        return `${this.notValidStatusColor}--text text--lighten-1 font-weight-bold`
      }
    },
    resetOrder() {
      this.clearEditedOrder()
      this.loadActive()
      this.order_comment = ''
    },
    clickResetButton() {
      this.dialogOptions = {
        title: 'Quote reset',
        message: 'Are you sure to reset the quote?',
        dialogBtns: [
          {
            title: 'Reset',
            color: 'red',
            click: () => {
              this.resetOrder()
              window.scrollTo(0, 0)
              this.isDialogVisible = false
            }
          },
          {
            title: 'Cancel',
            click: () => {
              this.isDialogVisible = false
            }
          }
        ]
      }
      this.isDialogVisible = true
    },
    showSendDialog(hasError) {
      if (hasError) {
        this.dialogOptions = {
          title: 'Error !',
          message: "Something went wrong. The order wasn't sent!",
          dialogBtns: [
            {
              title: 'Close',
              click: () => {
                this.isDialogVisible = false
              }
            }
          ]
        }
      } else {
        this.dialogOptions = {
          title: 'Success !',
          message: `The order was sent. If you have any additional questions, please call us <a href="tel:(612) 470 -7008">(612) 470 -7008</a>`,
          dialogBtns: [
            {
              title: 'Close',
              click: () => {
                this.isDialogVisible = false
                this.resetOrder()
              }
            }
          ]
        }
      }
      this.isDialogVisible = true
    },
    sendOrder() {
      if (this.valid) {
        const order = { fields: {}, fieldsFixed: {} }
        this.fieldsState.forEach(field => {
          if (field.enabled) {
            if (field.data.editAble) {
              order.fields[field.data.title] = (this.editedOrder.fieldsValues[field._id] &&
                this.editedOrder.fieldsValues[field._id].value) || { text: '' }
              if (field.data.comment) {
                order.fields[field.data.title].comment = field.data.comment
              }
            } else {
              order.fieldsFixed[field.data.title] = (this.editedOrder.fieldsValues[field._id] &&
                this.editedOrder.fieldsValues[field._id].value) || { text: '' }
              if (field.data.comment) {
                order.fieldsFixed[field.data.title].comment = field.data.comment
              }
            }
          }
        })
        order.price = { text: this.editedOrder.currentPrice.toFixed(2) }
        order.userId = { text: this.user().id }
        if (this.order_comment) order.comment = this.order_comment
        order.status = ORDER_STATUSES.INITIAL_STATUS
        if (this.add(order)) {
          this.showSendDialog()
        } else {
          this.showSendDialog(true)
        }
      }
    }
  },
  mounted() {
    if (this.allFields().length === 0) this.loadActive()
    else {
      this.fieldsState = [...this.fields]
      this.setFieldsEnabledProperty()
    }
    this.order_comment = this.editedOrder.orderComment
  }
}
</script>

<style scoped>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 10px;
}
.header-chip {
  display: inline-block;
  border-radius: 50px;
  border: 2px solid;
  padding: 2px 5px 2px 1px;
}
.valid-chip {
  color: white;
  border-color: #8bb93e;
}
.white-spaced {
  white-space: nowrap;
  width: 100%;
}
.parent {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  margin: 0 0;
  height: 48px;
}
.parent:after {
  content: ' ';
  position: absolute;
  right: 0;
  width: 80px;
  top: 0;
  height: 100%;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #3f3735 95%, #3f3735 100%);
}
.v-expansion-panel-header:not(.v-expansion-panel-header--active):hover .parent:after {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #473f3d 95%, #473f3d 100%);
}
.v-expansion-panel-header--active .parent:after {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #564f4d 95%, #564f4d 100%);
}
.keep-icon-upright {
  transform: unset !important;
}
</style>
